// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vlbW_","name":"styles_name__1ciTe","phone":"styles_phone__npRqg"};